/* Progressive enhancement: native anchors, forms, details and scroll remain usable without JS. */
(() => {
  // Do not restore consent from cart attributes or the browser back/forward cache.
  const resetConsent = () => document.querySelectorAll('[data-msp-consent]').forEach((input) => { input.checked = false; });
  window.addEventListener('pageshow', resetConsent);
  function setup(root = document) {
    root.querySelectorAll('[data-msp-consent]').forEach((input) => { input.checked = false; });
    root.querySelectorAll('[data-msp-carousel]').forEach((carousel) => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('[data-track]');
      if (!track) return;
      const controls = carousel.querySelector('[data-controls]');
      if (controls) controls.hidden = false;
      const previous = carousel.querySelector('[data-previous]');
      const next = carousel.querySelector('[data-next]');
      const update = () => {
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const advance = (direction) => track.scrollBy({
        left: direction * ((track.firstElementChild?.getBoundingClientRect().width || track.clientWidth) + 24),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
      previous?.addEventListener('click', () => advance(-1));
      next?.addEventListener('click', () => advance(1));
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      update();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  const sticky = document.querySelector('[data-msp-sticky]');
  const hero = document.querySelector('[data-msp-hero-cta]');
  if (!sticky || !hero || !('IntersectionObserver' in window)) return;
  const exclusions = [...document.querySelectorAll('.msp-section .msp-button, [data-msp-footer]')];
  const visible = new Set();
  const update = () => {
    const passedHero = hero.getBoundingClientRect().bottom < 0;
    const inputFocused = /^(INPUT|SELECT|TEXTAREA)$/.test(document.activeElement?.tagName || '');
    const keyboardOpen = window.visualViewport && window.visualViewport.height < window.innerHeight * 0.75;
    const show = matchMedia('(max-width: 749px)').matches && passedHero && !visible.size && !inputFocused && !keyboardOpen;
    if (!show && sticky.contains(document.activeElement)) return;
    sticky.hidden = !show;
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
    update();
  });
  exclusions.forEach((element) => observer.observe(element));
  new IntersectionObserver(update).observe(hero);
  window.addEventListener('resize', update, { passive: true });
  window.visualViewport?.addEventListener('resize', update, { passive: true });
  document.addEventListener('focusin', update);
  document.addEventListener('focusout', () => requestAnimationFrame(update));
  update();
})();
